//@flow
import type { FluxStandardAction } from 'modules/helper';
import type { GalleryImageType, RecommendedScreenType } from 'types/common';
import { RestaurantActionTypes } from './actionTypes';

export type RestaurantState = {
  categories: Array<RestaurantCategory> | null,
  gallery: Array<GalleryImageType> | null,
  allRestaurants: Array<RecommendedScreenType> | null,
  banner: Array<Restaurant> | null,
  beer: Array<Beers> | null,
  closeModal: boolean,
  loading: {
    categories: boolean,
    gallery: boolean,
    allRestaurants: boolean,
    banner: boolean,
    beer: boolean,
  },
  error: {
    categories: string | null,
    gallery: string | null,
    allRestaurants: string | null,
    banner: string | null,
    beer: string | null,
  },
};

const initialState: RestaurantState = {
  categories: null,
  gallery: null,
  allRestaurants: null,
  banner: null,
  beer: null,
  closeModal: false,
  loading: {
    categories: false,
    gallery: false,
    allRestaurants: false,
    banner: false,
    beer: false,
  },
  error: {
    categories: null,
    gallery: null,
    allRestaurants: null,
    banner: null,
    beer: null,
  },
};

export const RestaurantReducer = (
  state: RestaurantState = initialState,
  action: FluxStandardAction
) => {
  const { type, payload, error } = action;

  switch (type) {
    // Menu Items
    case RestaurantActionTypes.CATEGORY.FETCH:
      return {
        ...state,
        categories: { ...state.loading, categories: true },
        error: { ...state.error, categories: null },
      };
    case RestaurantActionTypes.CATEGORY.SUCCESS:
      return {
        ...state,
        categories: payload,
        loading: { ...state.loading, categories: false },
      };
    case RestaurantActionTypes.CATEGORY.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, categories: false },
        error: { ...state.error, categories: error },
      };
    // Gallery
    case RestaurantActionTypes.GALLERY.FETCH:
      return {
        ...state,
        loading: { ...state.loading, gallery: true },
        error: { ...state.error, gallery: null },
      };
    case RestaurantActionTypes.GALLERY.SUCCESS:
      return {
        ...state,
        gallery: payload,
        loading: { ...state.loading, gallery: false },
      };
    case RestaurantActionTypes.GALLERY.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, gallery: false },
        error: { ...state.error, gallery: error },
      };
    case RestaurantActionTypes.ALL_RESTAURANTS.FETCH:
      return {
        ...state,
        loading: { ...state.loading, allRestaurants: true },
        error: { ...state.error, allRestaurants: null },
      };
    case RestaurantActionTypes.ALL_RESTAURANTS.SUCCESS:
      return {
        ...state,
        allRestaurants: payload,
        loading: { ...state.loading, allRestaurants: false },
      };
    case RestaurantActionTypes.ALL_RESTAURANTS.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, allRestaurants: false },
        error: { ...state.error, allRestaurants: error },
      };
    //Detail Banner
    case RestaurantActionTypes.BANNER.FETCH:
      return {
        ...state,
        loading: { ...state.loading, banner: true },
        error: { ...state.error, banner: null },
      };
    case RestaurantActionTypes.BANNER.SUCCESS:
      return {
        ...state,
        banner: payload,
        loading: { ...state.loading, banner: false },
      };
    case RestaurantActionTypes.BANNER.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, banner: false },
        error: { ...state.error, banner: error },
      };
    //  Beer Explorer
    case RestaurantActionTypes.BEER.FETCH:
      return {
        ...state,
        loading: { ...state.loading, beer: true },
        error: { ...state.error, beer: null },
      };
    case RestaurantActionTypes.BEER.SUCCESS:
      return {
        ...state,
        beer: payload,
        loading: { ...state.loading, beer: false },
      };
    case RestaurantActionTypes.BEER.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, beer: false },
        error: { ...state.error, beer: error },
      };
    case RestaurantActionTypes.TOGGLE_MENU_MODAL.TOGGLE_MODAL:
      return {
        ...state,
        closeModal: payload,
      };
    default:
      return state;
  }
};
